import { z } from 'zod';
export const firstPaymentAuthorizationFormSchema = z.object({
    paymentOption: z.enum(['minimum', 'suggested']),
    acknowledged: z.boolean().refine((value) => value),
});
